export const configurationColumnTableStableA = {
  activityDate: true /*required field*/,
  done: true /*required field*/,
  type: true /*required field*/,
  stableNames: true /*required field*/,
  stableBoxNames: true,
  totalAnimals: true,
  productNames: true,
  userNames: true,
  tractorNames: true,
  equipmentNames: true,
  note: true,
};
